export default __webpack_public_path__ + "static/media/LogoBlack.417b7b62.svg";